import { useRef } from 'react';
import {
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  NoInfer,
  useQuery as useApolloQuery,
} from '@apollo/client';
import { DocumentNode } from 'graphql';

interface useQueryCustomOptions {
  memoized?: boolean;
}

export function useQuery<TData = any, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<NoInfer<TData>, NoInfer<TVariables>> & useQueryCustomOptions,
) {
  const { memoized = true, ...restQueryOptions } = options || {};
  const { data: _data, ...restQueryResult } = useApolloQuery(query, restQueryOptions);

  const previousDataRef = useRef<typeof _data>(_data);

  let data: TData | undefined = _data;

  if (memoized) {
    if (_data !== undefined && previousDataRef.current !== _data) {
      previousDataRef.current = _data;
    }

    if (_data === undefined && previousDataRef.current !== undefined) {
      data = previousDataRef.current;
    }
  }

  return { data, ...restQueryResult };
}
